import { Button } from "@/components/ui/button";
import zionHero from "@/assets/zion-national-park-southern-utah-real-estate.webp";
import zionHero960 from "@/assets/zion-national-park-southern-utah-real-estate-960w.webp";
import zionHero1440 from "@/assets/zion-national-park-southern-utah-real-estate-1440w.webp";
import zionHeroAvif from "@/assets/zion-national-park-southern-utah-real-estate.avif";
import zionHeroAvif960 from "@/assets/zion-national-park-southern-utah-real-estate-960w.avif";
import zionHeroAvif1440 from "@/assets/zion-national-park-southern-utah-real-estate-1440w.avif";
import { useScrollAnimation, fadeInUp, staggerContainer, AnimatedDiv, AnimatedH2 } from "@/hooks/useScrollAnimation";


const HeroThird = () => {
  const { ref, controls } = useScrollAnimation();
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <picture>
          <source
            type="image/avif"
            srcSet={`${zionHeroAvif960} 960w, ${zionHeroAvif1440} 1440w, ${zionHeroAvif} 1920w`}
            sizes="100vw"
          />
          <img
            src={zionHero}
            srcSet={`${zionHero960} 960w, ${zionHero1440} 1440w, ${zionHero} 1920w`}
            sizes="100vw"
            alt="Zion National Park real estate near St. George Utah with scenic red canyon views"
            className="w-full h-full object-cover"
            width={1920}
            height={1080}
            loading="lazy"
            decoding="async"
          />
        </picture>
        <div className="hero-overlay absolute inset-0"></div>
      </div>


      {/* Content */}
      <AnimatedDiv 
        ref={ref}
        initial="hidden"
        animate={controls}
        variants={fadeInUp}
        className="relative z-10 text-center max-w-4xl mx-auto px-4 md:px-6"
      >
        <AnimatedH2 
          variants={fadeInUp}
          className="text-sm md:text-lg text-white mb-3 md:mb-4 tracking-wider uppercase font-light"
        >
          Gateway to Zion
        </AnimatedH2>
        <AnimatedH2 
          variants={fadeInUp}
          className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl heading-luxury text-white mb-4 md:mb-6"
        >
          LIVE WHERE OTHERS VACATION
        </AnimatedH2>
      </AnimatedDiv>

      {/* Bottom Content */}
      <AnimatedDiv 
        initial="hidden"
        animate={controls}
        variants={staggerContainer}
        className="absolute bottom-12 md:bottom-16 left-4 right-4 md:left-6 md:right-6 z-10"
      >
        <div className="text-center">
          <div className="flex flex-wrap justify-center gap-2 md:gap-4">
            <AnimatedDiv variants={fadeInUp}>
              <Button 
                variant="outline"
                className="bg-transparent border-white text-white hover:bg-primary hover:text-white hover:border-primary backdrop-blur-sm px-4 md:px-6 py-2 text-sm md:text-base"
                onClick={() => window.location.href = '/search?boardId=97&minListPrice=1000000&propertyType=SFR&sort=priceDesc&status=active'}
              >
                Luxury Homes
              </Button>
            </AnimatedDiv>
            <AnimatedDiv variants={fadeInUp}>
              <Button 
                variant="outline"
                className="bg-transparent border-white text-white hover:bg-primary hover:text-white hover:border-primary backdrop-blur-sm px-4 md:px-6 py-2 text-sm md:text-base"
                onClick={() => window.location.href = '/search?boardId=97&boundaryWKT=POLYGON%28%28-113.59753575936884%2037.12200090294395%2C-113.5683962406309%2037.12200090294395%2C-113.5683962406309%2037.09521472860054%2C-113.59753575936884%2037.09521472860054%2C-113.59753575936884%2037.12200090294395%29%29&bedrooms=0&bathCount=0&propertyType=SFR,CND&status=active&sort=importDate&dateRange=0'}
              >
                New Listings
              </Button>
            </AnimatedDiv>
            <AnimatedDiv variants={fadeInUp}>
              <Button 
                variant="outline"
                className="bg-transparent border-white text-white hover:bg-primary hover:text-white hover:border-primary backdrop-blur-sm px-4 md:px-6 py-2 text-sm md:text-base"
                onClick={() => window.location.href = '/55-plus-communities'}
              >
                55+ Communities
              </Button>
            </AnimatedDiv>
          </div>
        </div>
      </AnimatedDiv>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 right-6 transform">
        <div className="w-px h-16 bg-primary/50 relative">
          <div className="w-2 h-2 bg-primary rounded-full absolute -left-0.5 top-0 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroThird;